/**
 * 创作者中心- 模型训练-测试模型
 * @returns
 */
import { useAppDispatch, useAppSelector } from "@/store/hooks";

import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  HStack,
  Image,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Radio,
  Input,
  Select,
  RadioGroup,
  Stack,
  SliderTrack,
  SliderThumb,
  SliderFilledTrack,
  Slider,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  SimpleGrid,
  useDisclosure,
  CircularProgress,
  CircularProgressLabel,
  Icon,
  IconButton,
  Center,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Textarea,
  Text,
  Link,
  useToast,
  useRadioGroup,
} from "@chakra-ui/react";
import {
  RiAddCircleFill,
  RiDeleteBin4Line,
  RiSendPlaneLine,
} from "@remixicon/react";
import { useCallback, useRef, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./modelSlick.css";
import { ModelPublishParams, ModelTrainingParams, TrainingPicture } from "@/types/creatorcenter";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";
import down from "@/assets/down.svg";
import {
  selectCurrentModelCover,
  selectModelcovers,
  selectTrainingParams,
  updateModelcovers,
  updateCurrentModelCover,
  selectModelPublishParams,
  updateModelPublishParams,
  selectCurrentTrainId
} from "@/reducer/mymodelSlice";
import modelImg from "@/assets/images/creator_model_img1.png";
import { useDropzone } from "react-dropzone";
import { useFormik } from "formik";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Model } from "@/types/design";
import TrainingBaseModesModal from "./trainingModes/trainingBaseModeModal";
import PayRadioCard from "./payRadioCard";
import PaySetting from "./paySetting";
import SaveSuccessModal from "./saveSuccessModal";
import { imageUploaded } from "@/services/api/thunks/image";
import { useTrainPublishMutation } from "@/services/api/endpoints/model";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const EditModelDetailModal = (props: Props) => {
  const { isOpen, onClose } = props;
  const currentModelcover = useAppSelector(selectCurrentModelCover);
  const modelcovers = useAppSelector(selectModelcovers);
  const toast = useToast();
  const user = useSelector(selectUser);
  const MarkingControl = useDisclosure();
  const largeModeControl = useDisclosure();
  const saveControl = useDisclosure();
  const dispatch = useAppDispatch();
  const trainingParams = useAppSelector(selectTrainingParams);

  const [isTesting, setIsTesting] = useState(false);
  const [coverImageId, setCoverImageId] = useState("1");
  const [modelValueType, setModelValueType] = useState("积分");
  const [modelValue, setModelValue] = useState<number>();
  const [agreement, setAgreement] = useState<boolean>(false);
  const maxSize = 20 * 1024 * 1024; // 2MB
  const [files, setFiles] = useState<File[]>([]);
  const modelPublishParams = useAppSelector(selectModelPublishParams);
  // const [modelPublishParams, setModelPublishParams] = useState<ModelPublishParams>({} as ModelPublishParams);
  const currentTrainId = useAppSelector(selectCurrentTrainId);

  const [trainPublish] = useTrainPublishMutation();


  const handleDrop = useCallback(async (acceptedFiles: File[]) => {
    // 处理接收到的文件，例如上传到服务器
    // dispatch(updateModelcovers([]));
    // if (files.length + acceptedFiles.length > 5) {
    //   toast({
    //     title: "图片数量超过5张，上传失败。",
    //     position: "top",
    //     status: "error",
    //   });
    // } else 
    if (acceptedFiles.length > 0) {
      var tmp = [];
      for (const file of acceptedFiles) {
        const formData = new FormData();
        formData.append('file', file);
        const response = await fetch('https://images.aldgptai.com/upload', {
          method: 'POST',
          body: formData
        });
        if (!response.ok) {
          throw new Error(`Server responded with status code ${response.status}`);
        }
        const result = await response.json();
        if (result.image_url) {
          tmp.push(result.image_url);
        }
      }
      const newModelcovers = [...modelcovers, ...tmp];
      dispatch(updateModelcovers(newModelcovers));
    }
  },
    [toast, files]
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    accept: {
      "image/*": [".jpeg", ".jpg", ".png"],
    },
    maxFiles: 9999,
    maxSize: maxSize,
    onDrop: handleDrop,
    noClick: true,
    multiple: true,
    noDrag: true,
    onDropRejected: () => {
      toast({
        title: "上传的文件类型(仅支持png、jpeg)或数量不符合要求！",
        position: "top",
        status: "error",
      });
    },
  });

  const handleOpen = () => {
    if (user && user.id) {
      open();
    } else {
      toast({
        title: "请登录系统",
        position: "top",
        status: "error",
        duration: 1000,
      });
    }
  };

  const handleOpenLargeModesModal = () => {
    largeModeControl.onOpen();
  };
  const changeBaseMode = (mode: Model) => {
    const newParams = { ...modelPublishParams, base_model: mode.realname };
    // setModelPublishParams(newParams)
    dispatch(updateModelPublishParams(newParams));
  };
  const hasValidate = (obj: ModelPublishParams) => {
    if (!obj.model_name) {
      return false
    }
    if (!obj.model_type) {
      return false
    }
    if (!obj.content_type) {
      return false
    }
    if (!obj.model_desc) {
      return false
    }
    if (!obj.base_model) {
      return false
    }
    if (!obj.trigger_word) {
      return false
    }
    if (!obj.weight) {
      return false
    }
    if (!obj.cfg_scale) {
      return false
    }

    return true;
  }
  const handleSaveAndPublish = async () => {
    const publishParams: ModelPublishParams = {
      ...modelPublishParams,
      id: currentTrainId,
      user_id: user.id,
      status: "已发布",
      model_cover: currentModelcover,
      model_preview: modelcovers
    }
    console.log(publishParams, "publishParams>>>>>>>>>>>")

    const res = hasValidate(modelPublishParams);
    if (res) {
      let result = await trainPublish(publishParams);
      if (result) {
        console.log(result, "result>>>>>21212")
        saveControl.onOpen();
      }
    } else {
      toast({
        title: "参数不能为空",
        position: "top",
        status: "error",
      });
    }
  }

  const handleDeleteCover = (image: string) => {
    const newModelcovers = modelcovers.filter(item => item !== image)
    dispatch(updateModelcovers(newModelcovers));
  }

  const handleChangeModelName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newParams = { ...modelPublishParams, model_name: e.target.value };
    dispatch(updateModelPublishParams(newParams));
    // setModelPublishParams(newParams)
  }
  const handleChangeModelType = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newParams = { ...modelPublishParams, model_type: e.target.value };
    // setModelPublishParams(newParams)
    dispatch(updateModelPublishParams(newParams));
  }

  const handleChangeCansee = (value: string) => {
    if (value === "true") {
      console.log(value)
      const newParams = { ...modelPublishParams, can_see: true };
      // setModelPublishParams(newParams)
      dispatch(updateModelPublishParams(newParams));
    }
    if (value === "false") {
      console.log(value)
      const newParams = { ...modelPublishParams, can_see: false };
      // setModelPublishParams(newParams)
      dispatch(updateModelPublishParams(newParams));
    }
  }

  const handleChangePaySettingRadio = (value: string) => {
    if (value === "true") {
      console.log(value)
      const newParams = { ...modelPublishParams, pay_setting: true };
      // setModelPublishParams(newParams)
      dispatch(updateModelPublishParams(newParams));
    }
    if (value === "false") {
      console.log(value)
      const newParams = { ...modelPublishParams, pay_setting: false };
      // setModelPublishParams(newParams)
      dispatch(updateModelPublishParams(newParams));
    }
  }

  const handleChangePaySetting = (value: string) => {
    if (value === "免费") {
      console.log(value)
      const newParams = { ...modelPublishParams, pay_setting: true };
      // setModelPublishParams(newParams)
      dispatch(updateModelPublishParams(newParams));
    }
    if (value === "会员下载") {
      console.log(value)
      const newParams = { ...modelPublishParams, pay_setting: false };
      // setModelPublishParams(newParams)
      dispatch(updateModelPublishParams(newParams));
    }
  }

  const handleChangeCl = (value: string) => {
    const newParams = { ...modelPublishParams, cl: Number(value) };
    // setModelPublishParams(newParams)
    dispatch(updateModelPublishParams(newParams));
  }
  const handleChangeCa = (value: string) => {
    const newParams = { ...modelPublishParams, ca: Number(value) };
    // setModelPublishParams(newParams)
    dispatch(updateModelPublishParams(newParams));
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent bg="#fff" h="100vh">
        <ModalHeader>
          <Flex justifyContent={"space-between"} alignItems="center" mr="60px">
            <HStack spacing={0}>
              <Text color="#27314D" fontSize={"18px"}>
                编辑模型信息
              </Text>
            </HStack>
            <Flex alignItems={"center"} gap="10px">
              <Button
                borderRadius={0}
                height={"40px"}
                color="#27314D"
                bg="rgba(238, 241, 247, 0.5)"
                fontWeight={"normal"}
                fontSize="14px"
                _hover={{
                  bg: "rgba(238, 241, 247, 0.5)",
                }}
                position={"relative"}
              >
                取消
              </Button>

              <Button
                borderRadius={0}
                height={"40px"}
                color="#FFFFFF"
                bgColor="#496AE1"
                fontWeight={"normal"}
                fontSize="12px"
                _hover={{
                  bgColor: "#3F5BC1",
                  color: "#E6E6E6",
                }}
                leftIcon={<RiSendPlaneLine size={"16px"} />}
                position={"relative"}
                onClick={handleSaveAndPublish}
              >
                保存并发布
              </Button>
            </Flex>
          </Flex>
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody>
          <Flex h={"100%"} gap="20px">
            {/* 左侧 */}
            <Flex
              h="100%"
              flex={1}
              p="12px"
              flexDir="column"
              border="1px solid #DCE0EB"
            >
              <HStack mb="14px">
                <Box color={"#27314D"} fontWeight="bold" fontSize={"16px"}>
                  效果图
                </Box>
              </HStack>

              <Box flex={1} h="0" overflowY={"auto"} position={"relative"}>
                <SimpleGrid columns={4} spacing={"40px 20px"}>
                  <Box
                    w="100%"
                    h={"160px"}
                    bg={"rgba(238, 241, 247, 0.5)"}
                    cursor="pointer"
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    <Flex
                      h={"100%"}
                      flexDir="column"
                      gap={"15px"}
                      justifyContent={"center"}
                      alignItems="center"
                      onClick={handleOpen}
                    >
                      <RiAddCircleFill color="#CBD1DF" size={"64px"} />
                      <Text fontSize={"14px"} color="#8E94A9">
                        点击上传封面效果图
                      </Text>
                    </Flex>
                  </Box>
                  {modelcovers &&
                    modelcovers.map((item) => (
                      <Box
                        key={item}
                        bg={"rgba(238, 241, 247, 0.5)"}
                        position="relative"
                      >
                        <Image
                          w="100%"
                          h={"160px"}
                          objectFit="cover"
                          src={item}
                        />
                        <IconButton
                          variant="unstyled"
                          aria-label="delete"
                          fontSize="16px"
                          position={"absolute"}
                          top="5px"
                          right={"5px"}
                          w="16px"
                          minW={"16px"}
                          h="16px"
                          icon={
                            <RiDeleteBin4Line color="#27314D" size={"16px"} />
                          }
                          onClick={() => handleDeleteCover(item)}
                        />
                        {currentModelcover === item && (
                          <Box
                            position={"absolute"}
                            top="5px"
                            left={"5px"}
                            bg="#000000"
                            color={"#FFFFFF"}
                            fontSize="10px"
                            p="2px"
                          >
                            模型封面
                          </Box>
                        )}
                        <Box
                          bg="rgba(39, 49, 77, 0.3)"
                          position={"absolute"}
                          bottom="0px"
                          left={"0px"}
                          w="100%"
                          p="10px 6px"
                        >
                          <Radio
                            value={item}
                            isChecked={currentModelcover === item}
                            onChange={(event) => {
                              dispatch(updateCurrentModelCover(item))
                            }}
                          >
                            <Text fontSize={"14px"} color={"#FFFFFF"}>
                              设为模型封面
                            </Text>
                          </Radio>
                        </Box>
                      </Box>
                    ))}
                </SimpleGrid>
              </Box>
            </Flex>
            {/* 右侧 */}
            <Box
              w="400px"
              h="100%"
              border="1px solid #DCE0EB"
              p="12px"
              boxSizing="border-box"
              overflow={"auto"}
            >
              {/* <Accordion
                allowToggle
                defaultIndex={[0]}
                borderColor={"#E2E8F0"}
                borderWidth="0 1px 0 1px"
                mb="20px"
                background="rgba(238, 241, 247, 0.5)"
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        color={"#27314D"}
                      >
                        模型信息
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel borderTop="1px solid #DCE0EB">
                    <TableContainer>
                      <Table borderWidth="1px">
                        <Tbody>
                          <Tr fontSize="14px">
                            <Td
                              // borderColor="gray.200"
                              // borderWidth="0 1px 1px 0"
                              borderWidth="1px"
                              color={"#8E94A9"}
                              p="10px"
                            >
                              模型名称
                            </Td>
                            <Td
                              p="10px"
                              borderWidth="1px"
                              whiteSpace="normal"
                              color={"#27314D"}
                            >
                              光怪陆离的建筑
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td borderWidth="1px" color={"#8E94A9"} p="10px">
                              训练方向
                            </Td>
                            <Td
                              color={"#27314D"}
                              borderWidth="1px"
                              p="10px"
                              whiteSpace="normal"
                            >
                              风格
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td borderWidth="1px" color={"#8E94A9"} p="10px">
                              图片类型
                            </Td>
                            <Td
                              color={"#27314D"}
                              p="10px"
                              borderWidth="1px"
                              whiteSpace="normal"
                            >
                              渲染图
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td borderWidth="1px" color={"#8E94A9"} p="10px">
                              触发标签
                            </Td>
                            <Td
                              color={"#27314D"}
                              borderWidth="1px"
                              p="10px"
                              whiteSpace="normal"
                            >
                              ALD001
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td borderWidth="1px" color={"#8E94A9"} p="10px">
                              模型类型
                            </Td>
                            <Td
                              color={"#27314D"}
                              borderWidth="1px"
                              p="10px"
                              whiteSpace="normal"
                            >
                              LoRA
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion> */}

              <Accordion
                allowToggle
                defaultIndex={[0]}
                borderColor={"#E2E8F0"}
                borderWidth="0 1px 0 1px"
                mb="20px"
                background="rgba(238, 241, 247, 0.5)"
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        color={"#27314D"}
                      >
                        模型说明
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel borderTop="1px solid #DCE0EB">
                    <Box>
                      <Flex alignItems={"center"} mb={"12px"}>
                        <HStack
                          fontSize="14px"
                          color={"#8E94A9"}
                          w="70px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>模型名称</Text>
                          <Text color={"#EC5F59"}>*</Text>
                        </HStack>
                        <Input
                          flex={1}
                          placeholder="请输入你的模型名称"
                          borderRadius={0}
                          bgColor="#EEF1F7"
                          h="40px"
                          border={"none"}
                          fontSize="14px"
                          color={"#27314D"}
                          value={modelPublishParams.model_name}
                          onChange={handleChangeModelName}
                        />
                      </Flex>

                      <Flex mb={"12px"} alignItems="center">
                        <HStack
                          fontSize="14px"
                          color={"#8E94A9"}
                          w="70px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>模型类型</Text>
                          <Text color={"#EC5F59"}>*</Text>
                        </HStack>
                        <Input
                          flex={1}
                          borderRadius={0}
                          bgColor="#EEF1F7"
                          h="40px"
                          border={"none"}
                          fontSize="14px"
                          color={"#27314D"}
                          // isDisabled={true}
                          value={modelPublishParams.model_type}
                          onChange={handleChangeModelType}
                        />
                      </Flex>
                      <Flex mb={"12px"} alignItems="center">
                        <HStack
                          fontSize="14px"
                          color={"#8E94A9"}
                          w="70px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>内容类型</Text>
                          <Text color={"#EC5F59"}>*</Text>
                        </HStack>
                        <Select
                          // isDisabled={true}
                          icon={<ReactSVG src={down} />}
                          variant="Unstyled"
                          flex={1}
                          bgColor="#EEF1F7"
                          placeholder="请选择"
                          h="40px"
                          border={"none"}
                          borderRadius={0}
                          fontSize="14px"
                          color={"#27314D"}
                          value={modelPublishParams.content_type}
                          onChange={(e) => {
                            // setModelPublishParams({
                            //   ...modelPublishParams,
                            //   content_type: e.target.value,
                            // });
                            dispatch(updateModelPublishParams({
                              ...modelPublishParams,
                              content_type: e.target.value,
                            }));
                          }}
                        >
                          <option value="建筑设计">建筑设计</option>
                          <option value="室内设计">室内设计</option>
                        </Select>
                      </Flex>
                      <Flex alignItems={"top"}>
                        <HStack
                          fontSize="14px"
                          color={"#8E94A9"}
                          w="70px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>模型介绍</Text>
                          <Text color={"#EC5F59"}>*</Text>
                        </HStack>
                        <Textarea
                          flex={1}
                          placeholder="简单介绍200字以内"
                          borderRadius={0}
                          bgColor="#EEF1F7"
                          border={"none"}
                          fontSize="14px"
                          color={"#27314D"}
                          value={modelPublishParams.model_desc}
                          onChange={(e) => {
                            // setModelPublishParams({
                            //   ...modelPublishParams,
                            //   model_desc: e.target.value,
                            // });
                            dispatch(updateModelPublishParams({
                              ...modelPublishParams,
                              model_desc: e.target.value,
                            }));
                          }}
                        />
                      </Flex>
                    </Box>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>

              <Accordion
                allowToggle
                defaultIndex={[0]}
                borderColor={"#E2E8F0"}
                borderWidth="0 1px 0 1px"
                mb="20px"
                background="rgba(238, 241, 247, 0.5)"
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        color={"#27314D"}
                      >
                        模型信息
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel borderTop="1px solid #DCE0EB">
                    <Box>
                      <Flex alignItems="center" mb={"12px"}>
                        <HStack
                          fontSize="14px"
                          color={"#8E94A9"}
                          w="70px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>基础模型</Text>
                          <Text color={"#EC5F59"}>*</Text>
                        </HStack>
                        <Flex
                          flex={1}
                          h="40px"
                          justifyContent={"space-between"}
                          alignItems="center"
                          p="0 10px"
                          bgColor="#EEF1F7"
                          border={"none"}
                          borderRadius={0}
                          fontSize="14px"
                          color={"#27314D"}
                        >
                          {modelPublishParams.base_model}
                        </Flex>
                      </Flex>
                      <Flex alignItems={"center"} mb={"12px"}>
                        <HStack
                          fontSize="14px"
                          color={"#8E94A9"}
                          w="70px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>触发词</Text>
                          <Text color={"#EC5F59"}>*</Text>
                        </HStack>
                        <Input
                          flex={1}
                          placeholder="请输入触发词"
                          borderRadius={0}
                          bgColor="#EEF1F7"
                          h="40px"
                          border={"none"}
                          fontSize="14px"
                          color={"#27314D"}
                          value={modelPublishParams.trigger_word}
                          onChange={(e) => {
                            // setModelPublishParams({
                            //   ...modelPublishParams,
                            //   trigger_word: e.target.value,
                            // });
                            dispatch(updateModelPublishParams({
                              ...modelPublishParams,
                              trigger_word: e.target.value,
                            }));
                          }}
                        />
                      </Flex>

                      <Flex mb={"12px"} alignItems="center">
                        <HStack
                          fontSize="14px"
                          color={"#8E94A9"}
                          w="70px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>建议权重</Text>
                          <Text color={"#EC5F59"}>*</Text>
                        </HStack>
                        <Input
                          flex={1}
                          borderRadius={0}
                          placeholder="建议权重(0.6-0.8)"
                          bgColor="#EEF1F7"
                          h="40px"
                          border={"none"}
                          fontSize="14px"
                          color={"#27314D"}
                          value={modelPublishParams.weight}
                          onChange={(e) => {
                            // setModelPublishParams({
                            //   ...modelPublishParams,
                            //   weight: e.target.value,
                            // });
                            dispatch(updateModelPublishParams({
                              ...modelPublishParams,
                              weight: e.target.value,
                            }));
                          }}
                        />
                      </Flex>
                      {/* <Flex mb={"12px"} alignItems="center">
                        <HStack
                          fontSize="14px"
                          color={"#8E94A9"}
                          w="70px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>模型权限</Text>
                          <Text color={"#EC5F59"}>*</Text>
                        </HStack>
                        <Select
                          icon={<ReactSVG src={down} />}
                          variant="Unstyled"
                          flex={1}
                          bgColor="#EEF1F7"
                          h="40px"
                          border={"none"}
                          borderRadius={0}
                          fontSize="14px"
                          color={"#27314D"}
                          // value={trainingParams.category}
                          // onChange={(e) => {
                          //   dispatch(
                          //     updateTrainingParams({
                          //       ...trainingParams,
                          //       category: e.target.value,
                          //     })
                          //   );
                          // }}
                        >
                          <option value="请选择VAE">请选择VAE</option>
                        </Select>
                      </Flex> */}
                      <Flex mb={"12px"} alignItems="center">
                        <HStack
                          fontSize="14px"
                          color={"#8E94A9"}
                          w="70px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>提示相关性</Text>
                          <Text color={"#EC5F59"}>*</Text>
                        </HStack>
                        <Input
                          flex={1}
                          borderRadius={0}
                          placeholder="请输入"
                          bgColor="#EEF1F7"
                          h="40px"
                          border={"none"}
                          fontSize="14px"
                          color={"#27314D"}
                          value={modelPublishParams.cfg_scale}
                          onChange={(e) => {
                            dispatch(updateModelPublishParams({
                              ...modelPublishParams,
                              cfg_scale: e.target.value,
                            }));
                          }}
                        />
                      </Flex>
                    </Box>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>

              <Accordion
                allowToggle
                defaultIndex={[0]}
                borderColor={"#E2E8F0"}
                borderWidth="0 1px 0 1px"
                mb="20px"
                background="rgba(238, 241, 247, 0.5)"
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        color={"#27314D"}
                      >
                        权限设置
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel borderTop="1px solid #DCE0EB">
                    <Box>
                      <Flex alignItems={"center"} mb={"12px"}>
                        <HStack
                          fontSize="14px"
                          h="40px"
                          color={"#8E94A9"}
                          w="90px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>可见范围</Text>
                          {/* <Text color={"#EC5F59"}>*</Text> */}
                        </HStack>
                        <Box flex={1}>
                          <RadioGroup value={modelPublishParams.can_see.toString()} onChange={handleChangeCansee}>
                            <Stack spacing={"20px"} direction="row">
                              <Radio value="true">
                                <Text fontSize={"14px"} color={"#3D3D3D"}>
                                  公开
                                </Text>
                              </Radio>
                              <Radio value="false">
                                <Text fontSize={"14px"} color={"#3D3D3D"}>
                                  仅自己可见
                                </Text>
                              </Radio>
                            </Stack>
                          </RadioGroup>
                        </Box>
                      </Flex>
                      <Flex alignItems={"center"} mb={"12px"}>
                        <HStack
                          fontSize="14px"
                          h="40px"
                          color={"#8E94A9"}
                          w="90px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>付费设置</Text>
                          {/* <Text color={"#EC5F59"}>*</Text> */}
                        </HStack>
                        <Box flex={1}>
                          <RadioGroup value={modelPublishParams.pay_setting.toString()} onChange={handleChangePaySettingRadio}>
                            <Stack spacing={"20px"} direction="row">
                              <Radio value="true">
                                <Text fontSize={"14px"} color={"#3D3D3D"}>
                                  免费
                                </Text>
                              </Radio>
                              <Radio value="false">
                                <Text fontSize={"14px"} color={"#3D3D3D"}>
                                  会员下载
                                </Text>
                              </Radio>
                            </Stack>
                          </RadioGroup>
                        </Box>
                      </Flex>

                      {/* <PaySetting val={modelPublishParams.pay_setting} handleChange={handleChangePaySetting} /> */}
                      <Flex alignItems={"top"} mb={"12px"}>
                        <HStack
                          fontSize="14px"
                          h="40px"
                          color={"#8E94A9"}
                          w="90px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>创作许可范围</Text>
                          {/* <Text color={"#EC5F59"}>*</Text> */}
                        </HStack>
                        <Box flex={1}>
                          <RadioGroup value={modelPublishParams.cl.toString()} onChange={handleChangeCl}>
                            <Stack spacing={"20px"} direction="column">
                              <Radio value="0">
                                <Text fontSize={"14px"} color={"#3D3D3D"}>
                                  允许在ALDGPT在线使用
                                </Text>
                              </Radio>
                              <Radio value="1">
                                <Text fontSize={"14px"} color={"#3D3D3D"}>
                                  允许下载生图
                                </Text>
                              </Radio>
                              <Radio value="2">
                                <Text fontSize={"14px"} color={"#3D3D3D"}>
                                  允许进行融合
                                </Text>
                              </Radio>
                            </Stack>
                          </RadioGroup>
                        </Box>
                      </Flex>
                      <Flex alignItems={"top"} mb={"12px"}>
                        <HStack
                          fontSize="14px"
                          h="40px"
                          color={"#8E94A9"}
                          w="90px"
                          mr="5px"
                          lineHeight={"40px"}
                          spacing="0"
                        >
                          <Text>商用权限</Text>
                          {/* <Text color={"#EC5F59"}>*</Text> */}
                        </HStack>
                        <Box flex={1}>
                          <RadioGroup value={modelPublishParams.ca.toString()} onChange={handleChangeCa} >
                            <Stack spacing={"20px"} direction="column">
                              <Radio value="0">
                                <Text fontSize={"14px"} color={"#3D3D3D"}>
                                  生成图片可出售或用于商业目的
                                </Text>
                              </Radio>
                              <Radio value="1">
                                <Text fontSize={"14px"} color={"#3D3D3D"}>
                                  允许模型转售或融合后出售
                                </Text>
                              </Radio>
                            </Stack>
                          </RadioGroup>
                        </Box>
                      </Flex>
                    </Box>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </Box>
          </Flex>
          <TrainingBaseModesModal
            isOpen={largeModeControl.isOpen}
            onClose={largeModeControl.onClose}
            changeBaseMode={changeBaseMode}
          />
          <SaveSuccessModal
            isOpen={saveControl.isOpen}
            onClose={saveControl.onClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EditModelDetailModal;
